import React from 'react';
import PropTypes from 'prop-types';
import {
  Divider, Modal, Space, Tag,
} from 'antd';

const itemText = (item, itemLabel) => item.name || `未命名${itemLabel}`;

const getDiff = (beforeItems = [], afterItems = []) => {
  const beforeMap = new Map(beforeItems.map((item) => [item.id, item]));
  const afterMap = new Map(afterItems.map((item) => [item.id, item]));
  const added = afterItems.filter((item) => !beforeMap.has(item.id));
  const removed = beforeItems.filter((item) => !afterMap.has(item.id));
  const changed = afterItems.filter((item) => {
    const before = beforeMap.get(item.id);
    return before && (before.name !== item.name || before.code !== item.code);
  }).map((after) => ({ before: beforeMap.get(after.id), after }));
  return { added, removed, changed };
};

export const getOperationDiffSummary = (beforeItems, afterItems, itemLabel = '权限') => {
  const { added, removed, changed } = getDiff(beforeItems, afterItems);
  const parts = [];
  if (added.length > 0) parts.push(`新增${added.length}`);
  if (removed.length > 0) parts.push(`移除${removed.length}`);
  if (changed.length > 0) parts.push(`修改${changed.length}`);
  return parts.length > 0 ? parts.join('、') : `无${itemLabel}变化`;
};

const renderItems = (items, color, itemLabel) => {
  if (items.length === 0) return <span>-</span>;
  return (
    <Space wrap>
      {items.map((item) => <Tag color={color} key={`${item.id}-${item.code || ''}`}>{itemText(item, itemLabel)}</Tag>)}
    </Space>
  );
};

const OperationLogDiff = ({
  visible, title, itemLabel, beforeItems, afterItems, onCancel,
}) => {
  const { added, removed, changed } = getDiff(beforeItems, afterItems);
  return (
    <Modal
      title={title}
      visible={visible}
      footer={null}
      width={900}
      onCancel={onCancel}
    >
      <div style={{ marginBottom: 12 }}>
        <Tag color="green">新增</Tag>
        <Tag color="red">移除</Tag>
        <Tag color="orange">修改</Tag>
      </div>
      <div>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>{`新增${itemLabel}`}</div>
        {renderItems(added, 'green', itemLabel)}
      </div>
      <Divider />
      <div>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>{`移除${itemLabel}`}</div>
        {renderItems(removed, 'red', itemLabel)}
      </div>
      <Divider />
      <div>
        <div style={{ marginBottom: 8, fontWeight: 500 }}>{`修改${itemLabel}`}</div>
        {changed.length === 0 ? <span>-</span> : (
          <Space direction="vertical" style={{ width: '100%' }}>
            {changed.map(({ before, after }) => (
              <div key={after.id}>
                <Tag color="orange">修改</Tag>
                <Tag>{itemText(before, itemLabel)}</Tag>
                <span style={{ margin: '0 8px' }}>→</span>
                <Tag color="orange">{itemText(after, itemLabel)}</Tag>
                {before.name === after.name && before.code !== after.code && (
                  <span style={{ marginLeft: 8, color: '#fa8c16' }}>{`${itemLabel}已更新`}</span>
                )}
              </div>
            ))}
          </Space>
        )}
      </div>
    </Modal>
  );
};

OperationLogDiff.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  itemLabel: PropTypes.string,
  beforeItems: PropTypes.arrayOf(PropTypes.shape({})),
  afterItems: PropTypes.arrayOf(PropTypes.shape({})),
  onCancel: PropTypes.func,
};

OperationLogDiff.defaultProps = {
  visible: false,
  title: '权限改动',
  itemLabel: '权限',
  beforeItems: [],
  afterItems: [],
  onCancel: () => {},
};

export default OperationLogDiff;
